"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ScatterplotOptions = /** @class */ (function () {
    function ScatterplotOptions() {
        this.width = 800;
        this.height = 400;
        this.data = Promise.resolve([]);
        this.color = ["#30c4c4", "#008d8d", "#0fb5b5", "#53d4d4", "#83e5e5"];
    }
    return ScatterplotOptions;
}());
exports.default = ScatterplotOptions;
